const brFloatFormat = (target_value) => {
  let value = target_value
    .replaceAll('.', '')
    .replaceAll(',', '')
    .replaceAll(/\D/g, '');

  const options = { minimumFractionDigits: 2 };
  const result = new Intl.NumberFormat('pt-BR', options).format(
    Number.parseFloat(value) / 100
  );

  if (
    value &&
    !Number.isNaN(
      result.replaceAll('.', '').replaceAll(',', '.').replaceAll(/\D/g, '')
    )
  ) {
    value = result;
  } else {
    value = '0,00';
  }

  return value;
};

export { brFloatFormat };
